export default __webpack_public_path__ + "static/Virsat Adipec 2022 Location-442bc4d9de85dfe131384e0b468a57b3.jpg";